import { FormBuilder, FormGroup } from "@angular/forms";
import { SeguridadService } from "../services/seguridad.service";
import { IResponse } from '../pages/base/interfaces';

export interface IBaseModel {
    id: number;
    id_creado_por:number;
    cod_creado_por: string;
    id_actualizado_por: number;
    cod_actualizado_por: number;
    fecha_creacion: Date;
    fecha_actualizacion: Date;
    version: number;
}

export interface ITipo {
    valor: number | string,
    nombre: string
}

export class BaseModel {
    
    private _seguridad = new SeguridadService();
    private _id: number;
    private _idCreadoPor: number;
    private _codCreadoPor: string;
    private _idActualizadoPor: number;
    private _codActualizadoPor: string;
    private _fechaCreacion: Date;
    private _fechaActualizacion: Date;
    private _version: number;

    private _serverJson: Record<string, any>;

    constructor() {
        this._version = 1;
        this._fechaCreacion = new Date();
        this._idCreadoPor = this._seguridad.getCurrentUser()?.id;
        this._codCreadoPor = this._seguridad.getCurrentUser()?.codigo;
    }

    public get seguridad() { return this._seguridad };

    public set id( id: number ) { this._id = id };
    public get id(): number { return this._id };

    public set idCreadoPor( idCreadoPor: number ) { this._idCreadoPor = idCreadoPor };
    public get idCreadoPor(): number { return this._idCreadoPor };

    public set codCreadoPor( codCreadoPor: string ) { this._codCreadoPor = codCreadoPor };
    public get codCreadoPor(): string { return this._codCreadoPor };

    public set idActualizadoPor( idActualizadoPor: number ) { this._idActualizadoPor = idActualizadoPor };
    public get idActualizadoPor(): number { return this._idActualizadoPor };

    public set codActualizadoPor( codActualizadoPor: string ) { this._codActualizadoPor = codActualizadoPor };
    public get codActualizadoPor(): string { return this._codActualizadoPor };

    public set fechaCreacion( fechaCreacion: Date ) { this._fechaCreacion = fechaCreacion };
    public get fechaCreacion(): Date { return this._fechaCreacion };

    public set fechaActualizacion( fechaActualizacion: Date ) { this._fechaActualizacion = fechaActualizacion };
    public get fechaActualizacion(): Date { return this._fechaActualizacion };

    public set version( version: number ) { this._version = version };
    public get version(): number { return this._version };

    public set serverJson( objeto: Record<string, any> ) { this._serverJson = objeto }
    public get serverJson(): Record<string, any> { return this._serverJson }


    async cargarObjeto( objeto: Record<string, any> ) {
        this._id = objeto.id;
        this._idCreadoPor = objeto.id_creado_por;
        this._codCreadoPor = objeto.creado_por?.codigo;
        this._idActualizadoPor = objeto.id_actualizado_por;
        this._codActualizadoPor = objeto.actualizado_por?.codigo;
        this._fechaCreacion = objeto.fecha_creacion ? new Date(objeto.fecha_creacion) : objeto.fecha_creacion;
        this._fechaActualizacion = objeto.fecha_actualizacion ?  new Date(objeto.fecha_actualizacion) : objeto.fecha_actualizacion;
        this._version = objeto.version;
    }

    /**
     * Metodo para crear el formulario de cada modelo
     */
    async getFormGroup(): Promise<FormGroup> {
        const fb = new FormBuilder();
        const form = fb.group({
            id:                     [this._id],
            id_creado_por:          [this._idCreadoPor],
            cod_creado_por:         [this._codCreadoPor],
            id_actualizado_por:     [this._idActualizadoPor],
            cod_actualizado_por:    [this._codActualizadoPor],
            fecha_creacion:         [{value: this._fechaCreacion, disabled: true}],
            fecha_actualizacion:    [{value: this._fechaActualizacion, disabled: true}],
            version:                [this.version],
        });
        
        return form;
    }

    async actualizarDatos( objeto: Record<string, any> ) {
        // await this.updateAuditoria(objeto);
        this._idActualizadoPor = objeto.id_actualizado_por;
    }

    async guardar( service: any ): Promise<IResponse> {
        return { ok: false, msg: 'No se ha proveido servicio correctamente', resp: 'Provea el servicio para guardar' };
    }

    async actualizar( service: any  ): Promise<IResponse> {
        return { ok: false, msg: 'No se ha proveido servicio correctamente', resp: 'Provea el servicio para guardar' };
    }

    async eliminar( service: any ): Promise<IResponse> {
        return { ok: false, msg: 'No se ha proveido servicio correctamente', resp: 'Provea el servicio para eliminar' };
    }

}

export class Detalle {

    private _seguridad = new SeguridadService();
    private _id: number;
    private _fila: number;

    public get seguridad() { return this._seguridad };

    set id( id: number ) { this._id = id };
    get id() { return this._id };

    set fila( fila: number ) { this._fila = fila };
    get fila() { return this._fila };

    async getFormGroup(): Promise<FormGroup> {
        const fb = new FormBuilder();
        const form = fb.group({
            id:                     [this._id],
            fila:                   [this._fila]
        });

        return form;
    }

    async cargarObjeto( objeto: Record<string, any> ) {
        this._id = objeto?.id;
        this._fila = objeto?.fila;

    }
}